var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhoneOutlineWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 23,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 1.5,
  d: "M23.167 21.556C8.233 21.556 2.722 7.925 1.834 1.11h7.11l1.778 5.333-3.555 1.778c1.422 4.267 5.926 7.704 8 8.89l2.667-2.668 5.333.89z"
})));
export { SvgPhoneOutlineWhite as ReactComponent };
export default "/_next/static/images/phone-outline-white.svg";